module.exports = __webpack_public_path__ + "img/gal_26.74b1562f.png";